import * as Yup from 'yup'

export const homeworkValidations = Yup.object().shape({
  storyId: Yup.number().required(),
  organizationId: Yup.number().required(),
  schoolId: Yup.number().required(),
  classroomId: Yup.number().required(),
  startDate:Yup.date().required(),
  requestVoiceRecording: Yup.boolean().required(),
  languageCode: Yup.string().required(),
});